export const messages = {
  en: {
    deleteProduct: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteProduct: 'Confirm to delete this product',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    deleteProduct: {
      confirmOperation: '请确认您的操作',
      confirmDeleteProduct: '确定删除该商品',
      cancel: '点错了',
      confirmDelete: '确认删除'
    }
  }
}